var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"discstest"},[_c('div',{staticClass:"discs"},_vm._l((4),function(i){return _c('img',{key:i,ref:"disc",refInFor:true,attrs:{"src":require('@/assets/discs/'+i+'.svg')}})}),0)])}
var staticRenderFns = []

export { render, staticRenderFns }